<div class="advanced-search-container" [attr.data-qa]="'advance-search-control1'">


  <form [attr.data-qa]="'advance-search-control2'">
    <ng-content></ng-content>
  </form>


  <div class="actions" [attr.data-qa]="'advance-search-control3'">
    <button type="button" (click)="onClear()" [attr.data-qa]="'advance-search-control4'"
            class="btn btn-link">{{'Common.AdvancedSearch.Clear' | translate}}</button>
    <button type="button" (click)="onSubmit()" [attr.data-qa]="'advance-search-control5'"
            class="btn btn-complete">{{'Common.AdvancedSearch.Search' | translate}}</button>
  </div>

</div>